$(document).on("click", ".collection-change-item", function () {
  var dataItem = $(this).attr("data-item");
  $(".collection-change-item").removeClass("active");
  $(this).addClass("active");
  if (dataItem == 1) {
    $(".collection-page-main .collection .product-grid").addClass(
      "product-item-1"
    );
  } else {
    $(".collection-page-main .collection .product-grid").removeClass(
      "product-item-1"
    );
  }
});
$(document).on("click", ".card-product-color-item", function () {
  var dataSrc = $(this).attr("data-src");
  var dataId = $(this).attr("data-id");
  $(".card-product-color-item").removeClass("active");
  $(this).addClass("active");
  $(".card-image-" + dataId).attr("src", dataSrc);
  $(".card-image-" + dataId).attr("srcset", dataSrc);
});
$(document).on("click", ".product-color-img", function () {
  var dataName = $(this).attr("data-name");
  $("legend.form__label.color-text-label span").text(dataName);
});





// $(".owl-carousel--2").owlCarousel({
//   loop: true,
//   margin: 2,
//   nav: true,
//   navText: [
//     "<img src='https://cdn.shopify.com/s/files/1/0707/3225/1439/files/Left_2x.svg?v=1674560124'>",
//     "<img src='https://cdn.shopify.com/s/files/1/0707/3225/1439/files/Right_2x.svg?v=1674560137'>",
//   ],
//   autoplay: true,
//   dots: false,
//   items: 3,
//   autoplayTimeout: 5000,
// });

//   $('.owl-carousel--2').slick({
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   infinite: true,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   centerPadding: '40px',
//   centerMode: true

// });
$(document).ready(function(){
  $('facets__disclosure-vertical js-filter initial').attr('open','')
  
})
$(document).ready(function () {
    // Step 1: Check if .tags_casrtmain exists
    if ($('div.tags_casrtmain').length) {
      
      // Step 2: Check if #pwzrswiper-container-wrapper exists
      if ($('#pwzrswiper-container-wrapper').length) {
        
        // Step 3: Append the Best Seller tag inside it
        $('#pwzrswiper-container-wrapper').append(
          '<div class="tags_casrt">' +
            '<p class="product-tag">Best Seller</p>' +
          '</div>'
        );
      }
    }
  });